/**
 * @fileoverview PATCH handler for the "/custom_objects/:type_name/:external_id" endpoint
 */
import fetch from "@lib/fetch";

import { customObjectsTypeName } from "../customObjectsTypeName/constants";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameExternalId } from "./constants";
import type {
  PatchCustomObjectsTypeNameExternalIdProps,
  PatchCustomObjectsTypeNameExternalIdResult,
} from "./types";

export const patchCustomObjectsTypeNameExternalId = reactQueryMutationAdapter(
  [customObjectsTypeName, customObjectsTypeNameExternalId],
  ({
    typeName,
    externalId,
    attributes,
  }: PatchCustomObjectsTypeNameExternalIdProps): Promise<PatchCustomObjectsTypeNameExternalIdResult> => {
    return fetch(
      `/custom_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(externalId)}`,
      "PATCH",
      { attributes },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
